import { useState } from "react";
import PropTypes from "prop-types";
import QuotationRoom from "app/pages/Booking/Quotation/Accommodation/QuotationRoom";
import "./QuotationRooms.scss";
import { accommodationTypeShape } from "app/utils/propTypes";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { FormattedMessage } from "react-intl";
import { Button } from "app/components/ui/Button/Button";
import { useFormikContext } from "formik";

const INITIAL_ACCOMMODATIONS_COUNT = 3;
const LOAD_MORE_INCREMENT = 3;

const QuotationRooms = ({ onBoardChange, accommodations = [], selectedAccommmodationCode }) => {
	const { track } = useAnalytics();

	const { values } = useFormikContext();

	const selectedAccommodationId = values?.accommodation;
	const selectedAccommodationIndex = accommodations.findIndex(
		accommodation => accommodation?.code === selectedAccommodationId
	);

	const [displayCount, setDisplayCount] = useState(
		selectedAccommodationIndex >= INITIAL_ACCOMMODATIONS_COUNT
			? Math.ceil((selectedAccommodationIndex + 1) / LOAD_MORE_INCREMENT) *
					LOAD_MORE_INCREMENT
			: INITIAL_ACCOMMODATIONS_COUNT
	);

	const hasMoreAccommodations = accommodations.length > displayCount;

	const handleShowMore = () => {
		setDisplayCount(prevCount => prevCount + LOAD_MORE_INCREMENT);
		track("accommodations_show_more");
	};

	return (
		<div className="quotation-rooms">
			{accommodations.slice(0, displayCount).map(accommodation => {
				return (
					<div
						className="quotation-rooms__item"
						key={accommodation.code}
						data-testid="quotation-rooms-item"
					>
						<QuotationRoom
							key={accommodation.code}
							accommodation={accommodation}
							onBoardChange={onBoardChange}
							selectedAccommmodationCode={selectedAccommmodationCode}
						/>
					</div>
				);
			})}

			{hasMoreAccommodations && (
				<Button
					variant="secondary"
					className="quotation-rooms__show-more-button"
					onClick={handleShowMore}
					data-testid="show-more-rooms-button"
				>
					<FormattedMessage id="quotation.accommodation.view.more" />
				</Button>
			)}
		</div>
	);
};

QuotationRooms.propTypes = {
	accommodations: PropTypes.arrayOf(PropTypes.shape(accommodationTypeShape)),
	onBoardChange: PropTypes.func,
	selectedAccommmodationCode: PropTypes.string,
};

export default QuotationRooms;
